(function() {
  'use strict';
  angular.module('admin', [
    'ui.bootstrap', 
    'common', 
    'registration',
    'dso',
    'ui.grid', 
    'ui.grid.resizeColumns',
    'ui.grid.selection',
    'ui.grid.pinning',
    'ui.grid.exporter',
    'ui.grid.moveColumns',
    'ui.grid.autoResize',
    'ui.grid.saveState']);
})();